import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/duties/leave-requests")({
  component: Outlet,
  beforeLoad(ctx) {
    return {
      getTitle: () => ctx.context.ts.absences.t("LeaveRequests_PageTitle"),
    }
  },
})
